import {usePageModelsStore} from "@/store/modules/pageModels";
import {storeToRefs} from "pinia";
import {GoingNewUtils} from "xmgoing-utils";

export function useCtlShowState({sectionConfig}) {
  const showCtlFlag = ref(unref(sectionConfig).showCtl);
  const showLoadingFlag=ref(unref(sectionConfig).loading);
  const hideFlag= ref(unref(sectionConfig).hiddenCtl);


  const pageModelsStore = usePageModelsStore();
  const {state} = storeToRefs(pageModelsStore);

  /**
   * 初始化显示状态
   */
  const initShowFlagState = function () {
    if(unref(sectionConfig).showCtl!==null){
      showCtlFlag.value=GoingNewUtils.parseBoolean(unref(sectionConfig).showCtl);
    }
    if (typeof (unref(sectionConfig).showCtlVuex) === 'string') {
      try{
        const vuex: any = {state: unref(state)}
        const fun = new Function("vuex", `return ${unref(sectionConfig).showCtlVuex}`);
        showCtlFlag.value=fun(vuex);
      }catch (e){
        console.warn(e,"======initShowFlagState======")
      }
    }
  }
  /**
   * 获取变量里面的值
   * @param vuexStr
   */
  const getStateVal=function (vuexStr){
    const vuex: any = {state: unref(state)}
    const fun = new Function("vuex", `return ${vuexStr}`);
    return fun(vuex);
  }

  /**
   * 初始化loading状态
   */
  const initLoadingState=function (){
    if(unref(sectionConfig).loading!==null){
      showLoadingFlag.value=GoingNewUtils.parseBoolean(unref(sectionConfig).loading);
    }
    if (typeof (unref(sectionConfig).loadingVuex) === 'string') {
      const vuex: any = {state: unref(state)}
      const fun = new Function("vuex", `return ${unref(sectionConfig).loadingVuex}`);
      showLoadingFlag.value=fun(vuex);
    }
  }

  onMounted(() => {
    initLoadingState();
    initShowFlagState();
  })

  /**
   * 监听对象显示、隐藏状态
   */
  watch(()=>unref(sectionConfig).showCtl, (newValue) => {
    initShowFlagState();
  })

  watch(()=>unref(sectionConfig).loading, (newValue) => {
    initShowFlagState();
  })

  /**
   * 监听对象vuex变化
   */
  if (unref(sectionConfig).showCtlVuex) {
    watch(unref(state), (newValue) => {
      initShowFlagState();
    })
  }

  if (unref(sectionConfig).loadingVuex) {
    watch(unref(state), (newValue) => {
      initLoadingState();
    })
  }

  const initVuexPropVal=function (vuexStr){
    try{
      const vuexObj: any = {state: unref(state)}
      const fun = new Function("vuex", `return ${vuexStr}`);
      return fun(vuexObj);
    }catch (e){
      console.warn(e,"========"+vuexStr)
    }
  }

  const getElShowFlag=function (outElement){
    const vuexStr=unref(outElement)['props']['showCtlVuex'];
    if(vuexStr){
     return  initVuexPropVal(vuexStr);
    }
    return true;
  }

  return {
    hideFlag,
    getElShowFlag,
    getStateVal,
    showLoadingFlag,
    showCtlFlag
  }
}
